import React, { useEffect, useState } from "react";
import style from "css/device.module.css";
import Consult from "../neat/consult";
import Questions from "components/app/questions";

function Nameplate(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className={style.device_title_wrap}>
        <div className={style.device_subtitle}>
          <span>
            스마트한 자율좌석 관리
            <br />
            전자명패 (NFC)
          </span>
        </div>
        <div className={style.device_title}>
          <div className={style.device_title_label}>Button Series 7.5</div>
        </div>
      </div>
      <div className={style.device_text}>
        실시간 자리 예약과 좌석 상태를{"\n"} Button 7.5 전자명패로 한눈에
        확인하고,
        <br />
        QR 코드를 통해 간편하게{"\n"} 체크인/체크아웃을 완료하세요.
        <br />
        자동 업데이트로 항상 최신 상태를 유지하여{"\n"} 자리를 효율적으로 관리할
        수 있습니다.
        <br />
      </div>

      <div className={style.device_img_list}>
        <img
          src={`${
            process.env.REACT_APP_CLIENT_URL
          }img/device/nameplate/name_plate_1${isMobile ? "_m" : ""}.png`}
          alt="nameplate"
        />
      </div>

      <div className={`${style.device_description_wrap} ${style.nameplate}`}>
        <div className={style.device_description_title}>
          스마트한 자율좌석제를 위한
          <br />
          전자명패 솔루션
        </div>
        <div className={style.device_description_text}>
          각 좌석에 부착된 <span>QR 코드를 통해</span> 사용자는 자리에{" "}
          <span>체크인/체크아웃</span>을 할 수 있습니다.
          <br />
          이를 통해 정확한 자리 사용 현황을{"\n"} 추적할 수 있으며, 실시간
          업데이트로 자율좌석제 운영이 더 간편해집니다.
        </div>
        <div className={style.device_description_img_wrap}>
          <div className={style.device_description_img_box}>
            <img
              src={`${
                process.env.REACT_APP_CLIENT_URL
              }img/device/nameplate/name_plate_check_in${
                isMobile ? "_m" : ""
              }.png`}
              alt="nameplate"
            />
            <span className={style.device_description_img_label}>
              체크인 화면
            </span>
          </div>
          <div className={style.device_description_img_box}>
            <img
              src={`${
                process.env.REACT_APP_CLIENT_URL
              }img/device/nameplate/name_plate_check_out${
                isMobile ? "_m" : ""
              }.png`}
              alt="nameplate"
            />
            <span className={style.device_description_img_label}>
              체크아웃 화면
            </span>
          </div>
        </div>
      </div>

      <div className={`${style.device_features_wrap} ${style.nameplate}`}>
        <div className={style.device_features_title}>
          <div>주요 기능 및 특징</div>
          <div>스마트 워크 환경을 완성하는 전자명패</div>
          <div>
            QR 기반 체크인과 체크아웃으로 좌석 관리의 효율성을 높이고,
            {"\n"}
            자율좌석제의 새로운 기준을 제시합니다.
          </div>
        </div>
        <div className={style.device_features_list}>
          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/nameplate/feature_name_plate_1${
                    isMobile ? "_m" : ""
                  }.png`
                }
                alt="feature1"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>1</div>
                <div className={style.device_features_item_label}>
                  실시간 예약 정보 표시
                </div>
              </div>
              <div className={style.device_features_text}>
                {isMobile
                  ? "사용자의 예약 정보와 실시간 사용 현황을 디지털로 표시하여, 해당 좌석이나 회의실의 현재 상태를 쉽게 확인할 수 있도록 합니다. 정보 업데이트를 실시간으로 반영하여 자리 중복 방지 및 불필요한 혼선을 최소화합니다."
                  : "사용자의 예약 정보와 실시간 사용 현황을 디지털로 표시하여, 해당 좌석이나 회의실의\n현재 상태를 쉽게 확인할 수 있도록 합니다. 정보 업데이트를 실시간으로 반영하여\n자리 중복 방지 및 불필요한 혼선을 최소화합니다."}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/nameplate/feature_name_plate_2${
                    isMobile ? "_m" : ""
                  }.png`
                }
                alt="feature2"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>2</div>
                <div className={style.device_features_item_label}>
                  자율 좌석제와 연동
                </div>
              </div>
              <div className={style.device_features_text}>
                {isMobile
                  ? "자율 좌석제 시스템과 연동하여 좌석 예약 및 사용 현황을 보여줍니다. 직원이나 방문자는 자리를 실시간으로 확인하고 예약할 수 있습니다. 공간 사용의 효율성을 높이며, 필요에 따라 즉시 자리 배정을 할 수 있어 편리함을 제공합니다."
                  : "자율 좌석제 시스템과 연동하여 좌석 예약 및 사용 현황을 보여줍니다.\n직원이나 방문자는 자리를 실시간으로 확인하고 예약할 수 있습니다.\n공간 사용의 효율성을 높이며, 필요에 따라 즉시 자리 배정을 할 수 있어 편리함을 제공합니다."}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/nameplate/feature_name_plate_3${
                    isMobile ? "_m" : ""
                  }.png`
                }
                alt="feature3"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>3</div>
                <div className={style.device_features_item_label}>
                  사용자 맞춤 정보 제공
                </div>
              </div>
              <div className={style.device_features_text}>
                {isMobile
                  ? "자리 사용자의 이름, 직위, 부서 등 필요한 정보가 자동 표시됩니다. 간편한 자리 확인이 가능하여 효율적인 업무 공간을 조성할 수 있습니다."
                  : "자리 사용자의 이름, 직위, 부서 등 필요한 정보가 자동 표시됩니다.\n간편한 자리 확인이 가능하여 효율적인 업무 공간을 조성할 수 있습니다."}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${style.device_support_wrap} ${style.nameplate}`}
        style={{
          backgroundImage: `url('${
            process.env.REACT_APP_CLIENT_URL
          }img/device/nameplate/name_plate_bg${isMobile ? "_m" : ""}.png')`,
        }}
      >
        <span>
          Button 7.5 전자명패는{"\n"} QR 코드 기반의{"\n"} 스마트
          체크인/체크아웃 기능으로
          <br />
          자율좌석제 운영을 효율적으로 관리해,
          <br />더 나은 자리 관리와{"\n"} 최적의 공간 활용을 지원합니다.
        </span>
      </div>

      {props.type === "popup" ? (
        <div style={{ marginBottom: "70px" }}>
          <Consult />
        </div>
      ) : (
        <div className={style.device_consult_wrapper}>
          <Questions />
        </div>
      )}
    </>
  );
}

export default Nameplate;
